<template>
    <select-label
        ref="select-detection"
        v-model="selected"
        :disabled="isDisabled"
        :editable="isEditable"
        :items="detectionTypes"
        :rules="rules"
        :append-icon="isDisabled ? '' : '$vuetify.icons.dropdown'"
        item-text="text"
        item-value="value"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AppContext } from '../../store/context';
const DetectionType = AppContext.DetectionType;
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'SelectorDetectionType',
    components: {
        SelectLabel,
    },
})
export default class SelectorDetectionType extends Vue {
    @Prop({ default: undefined }) value: number | undefined;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: () => [] }) rules: any[];
    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.selected = val;
    }
    @Watch('selected')
    onDetectionTypeChanged(newValue: string): void {
        this.$emit('input', newValue);
    }

    detectionTypes = [];
    selected = '';

    created() {
        this.detectionTypes = DetectionType.map(kv => {
            return { text: (this as any).$t(kv.text_key), value: kv.value };
        });
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }

    reset(): void {
        (this as any).$refs['select-detection'].reset();
    }
}
</script>
